import React from "react";
import PasswordReset from "../../components/ForgotPassword/PasswordReset";

const PasswordResetPage = () => {
  return (
    <div className="min-h-screen">
      <br />
      <br />
      <PasswordReset />
    </div>
  );
};

export default PasswordResetPage;
